module.exports = __webpack_public_path__ + "static/img/label-07.3cff18a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/label-07.png
// module id = UT6L
// module chunks = 150